import script from "./RcContentGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcContentGroup.vue?vue&type=script&setup=true&lang=ts"

import "./RcContentGroup.vue?vue&type=style&index=0&id=02f396ac&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02f396ac"]])

export default __exports__